module.exports = __webpack_public_path__ + "img/submit_students_img2.5d140a1a.png";